import React from "react"

import { isGifImage } from "components/cloudinary-image"

import { Wrapper, ImageLink, ImageCropped, Media, Caption, CreditSource } from "./styles"

const Image = ({ element, isPremium }) => {
  const { anchor, image } = element
  const priority = element.priority || 2

  const formatCreditSource = ({ credit, source, imageType }) => {
    const by = imageType ? `${imageType} by` : "Image by"

    if (credit && !isPremium) {
      return `${by} <b>${credit}</b>${source ? ` / ${source}` : ""}`
    }

    if (credit && isPremium) {
      return `${by} ${credit}${source ? ` / ${source}` : ""}`
    }

    if (source) {
      return `${by} ${source}`
    }

    return ""
  }

  const imageSizes = {
    1: {
      1024: [1040, 99999],
      768: [623, 99999],
      0: [480, 99999],
    },
    2: {
      1024: [580, 99999],
      768: [623, 99999],
      0: [480, 99999],
    },
    3: {
      1024: [280, 99999],
      768: [623, 99999],
      0: [480, 99999],
    },
  }

  const renderImage = () => (
    <ImageCropped
      imageData={image}
      sizes={[
        {
          query: 1024,
          width: imageSizes[priority][1024][0],
          height: imageSizes[priority][1024][1],
          transforms: `w_${imageSizes[priority][1024][0]},q_auto,f_auto,fl_lossy`,
        },
        {
          query: 768,
          width: imageSizes[priority][768][0],
          height: imageSizes[priority][768][1],
          transforms: `w_${imageSizes[priority][768][0]},q_auto,f_auto,fl_lossy`,
        },
        {
          query: 0,
          width: imageSizes[priority][0][0],
          height: imageSizes[priority][0][1],
          transforms: `w_${imageSizes[priority][0][0]},q_auto,f_auto,fl_lossy`,
        },
      ]}
      alt={image.altText}
      contain
      lazy
    />
  )

  return (
    <Wrapper id={`mbg-${anchor}`} priority={priority}>
      {image.path && !isGifImage(image.path) && image.linkUrl ? (
        <ImageLink
          href={image.linkUrl}
          target="_blank"
          {...(image.nofollowUrl && { rel: "nofollow" })}
        >
          {renderImage()}
        </ImageLink>
      ) : (
        renderImage()
      )}
      <Media>
        {image.caption && <Caption>{image.caption}</Caption>}
        {(image.credit || image.source) && (
          <CreditSource
            dangerouslySetInnerHTML={{
              __html: formatCreditSource(image),
            }}
          />
        )}
      </Media>
    </Wrapper>
  )
}

export default Image
